<template>
    <section class="blockElement">
        <div class="container-fluid">
            <!-- <div class="riskWarningMsg d-md-none">
                <small>{{$t('riskWarningMsg')}}</small> 
            </div> -->
            <div class="innerInclude p_login">
                <div class="row">
                    
                    <div class="col-12 col-md-4 text-center d-flex blueBG beforeBG  vh_100 align-items-center justify-content-center ">
                        <div class="d-none d-md-block">
                            <div class="titleArera Loginlogo">
                                <router-link :to="'/'" class="green">
                                    <img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView">
                                </router-link>
                            </div>
                            <div class="PortfoliosTitle"> 
                                <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <!-- <p>{{ $t('welcomeMsg') }}</p> -->
                                            <img src="../../../../static/fxView/images/login_trading_platform.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadone')}}</h3>
                                            <p>{{$t('welcomeMsg1')}}</p>       
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_trader_toolbox.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadtwo')}}</h3>
                                            <p>{{$t('welcomeMsg2')}}</p>
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_download_platform.svg" alt="Banner">
                                            <h3>{{$t('welcomeMsgHeadthree')}}</h3>
                                            <p>{{$t('welcomeMsg3')}}</p>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <ul class="carousel-indicators mt-3">
                                        <li data-target="#demo" data-slide-to="0" class="active"></li>
                                        <li data-target="#demo" data-slide-to="1"></li>
                                        <li data-target="#demo" data-slide-to="2"></li>
                                    </ul>
                                </div>
                            </div> 
                        </div> 
                    </div>
                    <!--loader - message--->
                    <div class="col-12 col-md-8 p-0 d-flex vh_100 align-items-center" v-if="insertId == '-1'">
                        <div class="sign_insec registerPage">
                            <div class="mobileLogo d-md-none">
                                <img src="../../../../static/fxView/images/fxview_logo.svg" alt="fxView">
                            </div>  
                            <div class="subtitle">
                                <h3 class="mb-4">{{$t('SignuptoFxView')}}</h3>
                                <!-- <p class="mb-3">{{$t('registerMsz1')}}</p> -->
                                <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                                <!--<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>-->
								<div>
									<div class="warningMsg mb-3 p-3 " v-if="response_msg != '' && msg_type == 'error'">
										<div class="infomsg d-flex align-items-center justify-content-between">
											<div class="d-flex w-100 align-items-center">
												<p v-html="response_msg">
													<feather type="alert-circle"></feather>
												</p>
											</div>  
											<feather type="x" @click="hideFunc()"></feather>  
										</div> 
									</div>
									<div class="warningMsg successMsg mb-3 p-3 " v-if="response_msg != '' && msg_type == 'success'">
										<div class="infomsg d-flex align-items-center justify-content-between">
											<div class="d-flex w-100 align-items-center">
												<p v-html= "response_msg">
													<feather type="check"></feather>
												</p>  
											</div>  
											<feather type="x" @click="hideFunc()"></feather>
										</div> 
									</div>
								</div>
							</div>
                            <div class="stepForm">
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " type="text" name="Name" v-model="username" class="float-field form-control" v-validate="'required'"   :class="{ 'is-invalid': submitted && errors.has('Name') }"  ref="nameInput"autocomplete="undefined" @focus="trackFzEvent('fName')"/>
                                    <label for="username" class="float-label">{{$t('YourName')}}</label>
                                    <p class="error" v-for="error in errors.collect('Name')">{{ error }}</p>
                                </div>
                                <!-- <div class="form-group field-wrapper">
                                    <input placeholder=" " type="text" name="fname" v-model="fname" class="float-field form-control" v-validate="required"   :class="{ 'is-invalid': submitted && errors.has('fname') }" ref="" />
                                    <label for="username" class="float-label">{{$t('fname')}}</label>
                                    <p class="error" v-for="error in errors.collect('fname')">{{ error }}</p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " type="text" name="lname" v-model="lname" class="float-field form-control" :class="{ 'is-invalid': submitted && errors.has('lname') }" ref="" />
                                    <label for="username" class="float-label">{{$t('lname')}}</label>
                                    <p class="error" v-for="error in errors.collect('lname')">{{ error }}</p>
                                </div> -->
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " type="text" name="Email" v-model="email" class="float-field form-control" v-validate="'required|email'"   :class="{ 'is-invalid': submitted && errors.has('Email') }" ref="emailInput" autocomplete="undefined" @focus="trackFzEvent('email')"/>
                                    <label for="username" class="float-label">{{$t('emailaddress')}}</label>
                                    <p class="error" v-for="error in errors.collect('Email')">{{ error }}</p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " :type="inputtype" name="Password" v-model="password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/}"   :class="{ 'is-invalid': submitted && errors.has('Password') }" ref="passwordInput" autocomplete="undefined" @focus="trackFzEvent('password')">  
                                    <label for="username" class="float-label">{{$t('enterpassword')}}</label>
                                    <feather :type="iconType" class="toggle-password" @click="switchVisibility"></feather>
                                    <!--<div v-if="!submitted && passwordErr" class="error">
										{{$t('passCharVal')}}
									</div>-->
                                    <p class="error" v-for="error in errors.collect('Password')">{{ error }}
                                        <!-- <span v-show="error == 'The Password field is required.'">{{$t('passwordFieldReq')}}</span>
										<span v-show="error == 'The Password field format is invalid.'">{{$t('passCharVal')}}</span> -->
                                    </p>
                                </div>
								<!-- <div class="form-group field-wrapper">
									<input placeholder=" " :type="inputtype2" v-model="confirm_password"  class="float-field form-control" v-validate="{ required: true, confirmed:password}"  :class="{ 'is-invalid': submitted && errors.has('confirm_password') }" ref="confirm_passwordInput" name="confirm_password"  autocomplete="undefined"/>
									<label for="password" class="float-label"> {{$t('conPassword')}}</label>
									<feather :type="iconType2" class="toggle-password" @click="switchVisibility1"></feather>
									<p class="error" v-for="error in errors.collect('confirm_password')">
										<span v-show="error == 'The confirm_password field is required.'">{{$t('passwordFieldReq')}}</span>
										<span v-show="error == 'The confirm_password field format is invalid.'">{{$t('passCharVal')}}</span>
										<span v-show="error == 'The confirm_password confirmation does not match.'">{{$t('newConfFieldSame')}}</span>
									</p>
								</div> -->
								
								<div class="form-group field-wrapper tabClass selectbox-style"  @click="tabActiveFun('2')">
									<v-select :options="countriesList" :reduce="name => name.iso2" label="name" v-model="res_country"  v-validate="'required'" name="Residence Country"  :class="((tabActive == '2' || res_country != '')?'active' :'') || ({ 'is-invalid': submitted && errors.has('Residence Country') })" class="customflaotField form-control" placeholder="" ref="countryList"   @focus="trackFzEvent('country')" />
									<label for="rescountry" class="float-label">{{$t('residenceCountry')}}</label>
                                    <p class="error" v-for="error in errors.collect('Residence Country')">
                                        <span v-show="error == 'The Residence Country field is required.'">{{$t('ResConrequired')}}</span>
                                    </p>
                                </div>
                                <div class="form-group field-wrapper co-phone-number-style">
                                    <vue-phone-number-input 
                                        v-model="mobile_number"  
                                        :no-example="true" 
                                        :default-country-code="getCountryCode()" 
                                        v-validate="{ required: true, min: 8, max: 15 }"
                                        ref="mobile_numberInput" 
                                        :class="{ 'is-invalid': submitted && errors.has('Mobile Number') }" 
                                        name="Mobile Number"
                                        @update="updatedText"
                                        @phone-number-focused="handlePhoneNumberFocused"
                                    />
                                    <!-- <p class="error" v-if="!(numberValid) && submitted">{{$t('InvalidNumber')}}</p> -->
                                    <p class="error" v-for="error in errors.collect('Mobile Number')">
                                        <span
                                            v-show="
                                            submitted &&
                                            error == 'The Mobile Number field is required.'">
                                            The Phone number is required.
                                        </span>
                                        <span
                                            v-show="
                                            error == 'The Mobile Number field must be at least 8 characters.'">
                                            The Phone Number field must have atleast 8 characters.
                                        </span>
                                        <span
                                            v-show="
                                            error ==
                                            'The Mobile Number, field may not be greater than 15 characters.'
                                            ">
                                            The Phone number field may not be greater than 15 characters.
                                        </span>
                                    </p>
                                </div>
                                <!-- <div class="form-group field-wrapper">
                                    <vue-phone-number-input
                                        v-model="mobile_no"
                                        :no-example="true"
                                        :default-country-code="default_country"
                                        v-validate="{ required: true, min: 8, max: 15 }"
                                        ref="mobile_numberInput"
                                        :class="{
                                            'is-invalid': submitted && errors.has('phone_no'),
                                        }"
                                        name="phone_no"
                                        @update="updatedText"
                                    />
                                    <p class="error" v-for="error in errors.collect('phone_no')">
                                        <span
                                            v-show="
                                            submitted &&
                                            error == 'The phone_no field is required.'">
                                            The Phone number is required.
                                        </span>
                                        <span
                                            v-show="
                                            error == 'The phone_no field must be at least 8 characters.'">
                                            The Phone Number field must have atleast 8 characters.
                                        </span>
                                        <span
                                            v-show="
                                            error ==
                                            'The phone_no field may not be greater than 15 characters.'
                                            ">
                                            The Phone number field may not be greater than 15 characters.
                                        </span>
                                    </p>
                                </div>	 -->	
                                <div class="form-group field-wrapper m-0 d-flex align-items-center justify-content-between">
                                    <div class="capticha">
                                        <vue-recaptcha class="captchaRegister"
                                            sitekey="6LcivBArAAAAADQ5sZSOf-5bbKHlE0pmqDxDt-ax" ref="recaptcha"
                                            @verify="onCaptchaVerified" @expired="onCaptchaExpired"
                                            size="visible"></vue-recaptcha>
                                        <p class="error">
                                            <span v-if="captachErr">{{ $t("captchaErr") }}</span>
                                        </p>
                                    </div>
                                </div>				
                                <div class="form-group field-wrapper mb-3">
                                    <p>{{$t('registerMsz3')}}<a :href="privacyPolicyLink" target="_blank">{{$t('privacyPolicy')}}</a>. </p>
                                </div>
                                <div class="clearfix"></div>
                                <div class="d-flex justify-content-between align-items-center submitButton">
                                    <button class="prism_btn btn_sm" v-on:click.prevent="create_new_lead()">{{$t('register')}}</button>
                                    <div class="forgot_sec">
                                        <div  @click="handleLoginRoute()">
                                            <router-link :to="'/'" class="tpArea">{{$t('haveAnAccount')}} </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center align-items-center py-3">
                                    <div class="modal-popup LoginPopup" v-if="res_country != '' && res_country != null && res_country != undefined && !european_countries_list.hasOwnProperty(res_country)">
                                        <div class="middleBox p-3 whiteBG">
                                            <p class="text-center" style="font-size: 14px;">
                                                {{$t('chEn_redirectmsg1')}}

                                                {{$t('chEn_redirectmsg2')}}
                                            </p>
                                            <div class="w-100 d-flex justify-content-center align-items-center mt-4 mb-3">
                                                <a @click="handleContinueEvent"  class="prism_btn btn_sm mr-3">{{$t('chEn_continue')}}</a>
                                                <a href="#" @click="res_country = ''" class="prism_btn btn_sm darkBG">{{$t('chEn_takeback')}}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <change-entity v-if="european_countries_list.hasOwnProperty(res_country)"></change-entity> -->
                                </div>
                                <app-language> </app-language>  
                                <div class="charlgateMsg border-top pt-2 mt-2">
                                    <small>{{$t('charlgateMsg')}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-8 p-0 text-center d-flex vh_100 align-items-center" v-else>
                        <div class="sign_insec">
                            <div class="subtitle text-center">
                                <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                            </div>
                            <div class="stepForm">
                                <div class="otpBlock">
                                    <img class=" mb-3" src="../../../../static/fxView/images/otp-1.png" />
                                    <p class="mb-3"> {{$t('registerMsz2')}} </p>
                                    <div class="form-group field-wrapper">
                                        <input placeholder=" " type="text" v-model="otp" name="OTP" class="float-field form-control" :class="{ 'is-invalid': submittedOtp && errors.has('OTP') }" v-validate="{ required: true, max: 6,numeric : true }" ref="otpInput" @focus="trackFzEvent('otp')">
                                        <label for="pannumber" class="float-label">{{$t('enterOtp')}} </label>
                                        <p class="error text-left" v-for="error in errors.collect('OTP')">{{ error }}</p>
                                    </div>
                                    <div class="signupbtn submitButton">
                                        <button class="prism_btn btn_sm mb-3" v-on:click="verify_lead()">{{$t('submit')}} </button>
										<div class="forgot_sec">
											<a href="#" class="tpArea underline" v-on:click.stop.prevent="resend()">{{$t('resendOtp')}} </a>
										</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 
            </div>
        </div>
		<div class="fixedBarBottom fullwidth register-page-fixedbar">
            <div class="footPromoLastBar  text-center">
                <p class="" v-html="$t('footerMsz2')"></p>
                <a href="https://fxview.com/assets/pdf/legal-document/Risk-Disclosure-and-Warnings-Notice-August-2023.pdf" target="_blank">{{$t('riskDisclaimer')}}</a> 
            </div>
			  
		</div>
    </section>
</template>

<script>
    const crypto = require('crypto');
    import * as types from '@/types'
    import { mapActions } from 'vuex'
	import language from '../shared/language_before_login'
    import { fxViewMixins } from '@/plugins/fxView'
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        name: 'Register',
        mixins: [fxViewMixins],
        data() {
            return {
                current_language: navigator.language.split('-')[0],
				residence_country : [],
				res_country : '',
                insertId : '-1',
                username : '',
                email :'',
                fname: '',
                lname:'',
                name : '',
                password : '',
				// confirm_password : '',
                mobile_number :'',
                otp : '',
                error_msg_password : '',
                submitted : false,
                submittedOtp : false,
                inputtype:'password',
                showpassword: false,
                iconType : 'eye-off',
                userCountry : '',
                pageLoader : false,
                response_msg : '',
                msg_type : '',
				passwordErr : false,
                numberValid: true,
                numberWithCountry:'',
                captchaVerified: false,
                captchaToken: '',
                captachErr: false,
                IBREFERLINK: '',
				tabActive : '',
				admin_id : '0',
				rm_id : '0',
                default_country: "GR",
				inputtype2:'password',
                showpassword2: false,
                iconType2 : 'eye-off',
            }
        },
		components: {
            appLanguage: language,
            VueRecaptcha
        },
        methods:{
			tabActiveFun(getData){
				this.tabActive = getData
			},
			hideFunc(){
				this.response_msg = ''
				this.msg_type =''
			},
            countryCookisGet() {
                if (this.$cookies.get("countrySelectedFromWebsite") != undefined) {
                    if (this.$cookies.get("countrySelectedFromWebsite") == "IN") {
                        // this.response_msg = 'you are not allowed to register in this portal'
                        // this.msg_type = 'error'
                    } else {
                        this.res_country = this.$cookies.get("countrySelectedFromWebsite");
                    }
                }
            },
            getCountryCode() {
                let country = '';
                if(this.res_country) {
                    country = this.res_country;
                } else if (this.userCountry !== 'N/A') {
                    country = this.userCountry;
                }
                return country;
            },
            switchVisibility() {
                this.showpassword = !this.showpassword
                if(this.showpassword){
                    this.inputtype = 'text'
                    this.iconType = 'eye'
                }else{
                    this.inputtype = 'password'
                    this.iconType = 'eye-off'
                } 
            },
			switchVisibility1() {
                this.showpassword2 = !this.showpassword2
                if(this.showpassword2){
                    this.inputtype2 = 'text'
                    this.iconType2 = 'eye'
                }else{
                    this.inputtype2 = 'password'
                    this.iconType2 = 'eye-off'
                } 
            },
            
            ...mapActions({
                _runUserSignUp: types.RUN_USER_SIGNUP,
                _runVerifyLeadOtp: types.RUN_VERIFY_LEAD_OTP,
                _runGetUserIp: types.RUN_GET_USER_IP
            }), 
            onCaptchaVerified: function (recaptchaToken) {
                // console.log(recaptchaToken, ">>>>>recaptchaToken")
                const self = this;
                
                this.captchaVerified = true
                this.captchaToken = recaptchaToken
                // self.$refs.recaptcha.reset();
                this.create_lead();
            },

            onCaptchaExpired: function () {
              this.$refs.recaptcha.reset();
            },
            resend(){
                this.$trackEvent('FXView+OTP+Resend');
                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(this.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');
                let firstname= this.username.split(' ')[0]
                let lastname = this.username.replace(firstname , '').trim();
                let input_json={
					'globalParams' :{
                        // "username" : this.username,
                        // "name" : this.name,
                        "fname": firstname,
                        "lname": lastname,
						"email": this.email,
						"mobile": this.numberWithCountry,
						"password" : hashedstr,
                        "captchaToken":this.captchaToken,
                        "IBREFERLINK":this.IBREFERLINK,
						"residence_country" : this.res_country,
					},
					'localParams' :{ "parameter" : this , 'page' : 'resend'}
				}
				this._runUserSignUp(input_json)
            },
            updatedText(e){
                this.numberWithCountry = e.formattedNumber
                this.numberValid = e.isValid
            },
            create_new_lead() {
                const _that = this;
                _that.hideFunc();
                _that.$refs.recaptcha.execute();
            },
            create_lead(){
                
                const _that = this
                _that.submitted = true;

                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');

                _that.$validator.validate().then(valid => {
                    if (valid) {
						let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/
						if(!regex.test(_that.password)) {
							_that.passwordErr = true
							_that.submitted = false;
						}
                        else if(!(this.captchaVerified)){
                            _that.captachErr = true
                            _that.submitted = false;
                        }
                        else{
							_that.passwordErr = false
							_that.submitted = false;
                            let firstname= _that.username.split(' ')[0]
                            let lastname = _that.username.replace(firstname , '').trim();
							let input_json={
								'globalParams' :{
                                    // "name" : this.name,
                                    // "username" : _that.username,
                                    "fname": firstname,
                                    "lname": lastname,
									"email": _that.email,
									"mobile": _that.numberWithCountry,
									"admin_id" : _that.admin_id,
									"rm_id" : _that.rm_id,
									"password" : hashedstr,
                                    "captchaToken":this.captchaToken,
									"residence_country" : _that.res_country,
                                    "IBREFERLINK":_that.IBREFERLINK
								},
								'localParams' :{ "parameter" : _that }
							}
                            if (_that.$cookies.get("investing_ref")) {
                                input_json.globalParams.investing_ref = _that.$cookies.get("investing_ref");
                            }
                            //===========in use==============
                            if(_that.$cookies.get('refLink') && _that.$cookies.get('refRm')){
                                input_json.globalParams.rm_id = _that.$cookies.get('refRm')
                                input_json.globalParams.admin_id = _that.$cookies.get('refLink')
                            }else if(_that.$cookies.get('IBREFERLINK')){
                                let decrpyLinRm = window.atob(_that.$cookies.get('IBREFERLINK').toString()) ; 
                                let decrpyLinRm1 = decrpyLinRm.split('||')
                                _that.$cookies.set("refLink",window.btoa(decrpyLinRm1[0]),"4y", null, _that.$env_var.cookieSaveUrl);
                                _that.$cookies.set("refRm",window.btoa(decrpyLinRm1[1]),"4y", null, _that.$env_var.cookieSaveUrl);
                                input_json.globalParams.rm_id = _that.$cookies.get('refRm')
                                input_json.globalParams.admin_id = _that.$cookies.get('refLink')
                            } 
                            this.$trackEvent('FXView+Register+Submit');
                            this.$trackEvent('FXView+OTP+Pageview');
							_that._runUserSignUp(input_json)
                            _that.$refs.recaptcha.reset();
						}
                        
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });

            },
            // verify_lead(){
            //     const _that = this
            //     _that.submittedOtp = true;

            //     const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
            //     let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
            //     hashedstr += mykey.final('hex');

            //     _that.$validator.validate().then(valid => {
            //         if (valid) {
            //             let input_json={
            //                 'globalParams' :{
            //                     "browser_language": _that.current_language,
            //                     "email": _that.email,
            //                     "mobile": _that.numberWithCountry,
            //                     "password" : hashedstr,
            //                     "OTP": _that.otp,
            //                     'ID': _that.insertId,
            //                     "IBREFERLINK":_that.IBREFERLINK
            //                 },
            //                 'localParams' :{ "parameter" : _that }
            //             }

            //             //===========in use==============
            //             if (_that.$cookies.get("investing_ref")) {
            //                 input_json.globalParams.investing_ref = _that.$cookies.get("investing_ref");
            //             }
            //             if(_that.$cookies.get('refLink') && _that.$cookies.get('refRm')){
            //                 input_json.globalParams.refLink = _that.$cookies.get('refLink')
            //                 input_json.globalParams.refRm = _that.$cookies.get('refRm')
            //             }else if(_that.$cookies.get('IBREFERLINK')){
            //                 let decrpyLinRm = window.atob(_that.$cookies.get('IBREFERLINK').toString()) ; 
            //                 let decrpyLinRm1 = decrpyLinRm.split('||')
            //                 _that.$cookies.set("refLink",window.btoa(decrpyLinRm1[0]),"4y", null, _that.$env_var.cookieSaveUrl);
            //                 _that.$cookies.set("refRm",window.btoa(decrpyLinRm1[1]),"4y", null, _that.$env_var.cookieSaveUrl);
            //                 input_json.globalParams.refLink = _that.$cookies.get('refLink')
            //                 input_json.globalParams.refRm = _that.$cookies.get('refRm')
            //             }
                        
            //             _that._runVerifyLeadOtp(input_json)
                        
            //         }else{
            //             _that.handleValidationErrorAdvanced(_that.errors)
            //         }
            //     });
            // },
            verify_lead() {
                this.$trackEvent('FXView+OTP+Submit');
                const _that = this;
                _that.submittedOtp = true;
                const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let hashedstr = mykey.update(_that.password, "utf8", "hex");
                hashedstr += mykey.final("hex");

                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            'globalParams': {
                                'browser_language': _that.current_language,
                                'email': _that.email,
                                'account_type': _that.account_type,
                                'mobile': _that.numberWithCountry,
                                'password': hashedstr,
                                'OTP': _that.otp,
                                'ID': _that.insertId,
                                'IBREFERLINK': _that.IBREFERLINK,
                                'ip_country': this.userCountry,
                            },
                            'localParams': { "parameter": _that },
                        };
                        //==not in use===============
                        if (_that.$cookies.get("referralId")) {
                            input_json.globalParams.referralId = _that.$cookies.get("referralId");
                        }
                        if (_that.$cookies.get("investing_ref")) {
                            input_json.globalParams.investing_ref = _that.$cookies.get("investing_ref");
                        }
                        //===========in use==============
                        if (_that.$cookies.get("refLink") && _that.$cookies.get("refRm")) {
                            input_json.globalParams.refLink = _that.$cookies.get("refLink");
                            input_json.globalParams.refRm = _that.$cookies.get("refRm");
                        } else if (_that.$cookies.get("IBREFERLINK")) {
                            let decrpyLinRm = window.atob(_that.$cookies.get("IBREFERLINK").toString());
                            let decrpyLinRm1 = decrpyLinRm.split("||");
                            _that.$cookies.set("refLink", window.btoa(decrpyLinRm1[0]), "4y", null, _that.$env_var.cookieSaveUrl);
                            _that.$cookies.set("refRm", window.btoa(decrpyLinRm1[1]), "4y", null, _that.$env_var.cookieSaveUrl);
                            input_json.globalParams.refLink = _that.$cookies.get("refLink");
                            input_json.globalParams.refRm = _that.$cookies.get("refRm");
                        }
                        // try {
                        //     __adroll.track("pageView", { segment_name: "4cfb31ed" });
                        // } catch (err) {}
                        _that._runVerifyLeadOtp(input_json);
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
			RemoveNode(iso2){
				return this.countriesList.filter(function(emp) {
					if (emp.iso2 == iso2) {
						return false;
					}
					return true;
				});
			},
            runVerify() {
                const encyptKey = this.$route.query["verify"];

                let mykey = crypto.createDecipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let mystr = mykey.update(encyptKey, "hex", "utf8");
                mystr += mykey.final("utf8");

                let infoArray = mystr.split("^");

                if (this.IBREFERLINK == "") {
                    this.IBREFERLINK = infoArray[5];
                }
                let input_json = {
                    globalParams: {
                        verify: this.$route.query["verify"],
                        ip_country: this.userCountry,
                    },
                    localParams: { parameter: this },
                };
                this._runVerifyLeadOtp(input_json);
            },
            setCritio(country){
                this.userCountry = country
                let p_countries = {'AE':104607,'AR':104608,'AU':103314,'BR':104609,'CA':104610,'DE':103065,'DK':103066,'ES':103313,'IT':104611,'KE':104612,'MA':104613,'NG':104614,'NL':103061,'PE':104615,'PL':104616,'PT':103312,'SA':104617,'SE':103309,'ZA':104618};
                if(p_countries[country]){
                    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                    /*var crypto = require('crypto');*/
                    try{
                        /*let email = crypto.createHash('md5').update(result.res_data.user.email).digest("hex");*/
                        // let email = crypto.createHash('md5').update('1').digest("hex")
                        let setAccount = { event: "setAccount", account: p_countries[country] };
                        let setEmail = { event: "setEmail", email: "" /*, hash_method: "md5"*/};
                        let setSiteType = { event: "setSiteType", type: deviceType};
                        let viewBasket = { event: "viewBasket", item: [
                            {id: "registration", price: "1", quantity: "1" }
                        ]};
                        /*console.log('critio-update-viewBasket-before :- ',JSON.stringify([setAccount,setEmail,setSiteType,viewBasket]))*/
                        window.criteo_q.push(setAccount,setEmail,setSiteType,viewBasket);
                        /*console.log('critio-update-viewBasket-after :- ',JSON.stringify([setAccount,setEmail,setSiteType,viewBasket]))*/
                    }catch(e){ console.log(e); }
                }
            },
            handleLoginRoute(){
                this.$trackEvent('FXView+Register+Login');
            },
            handlePhoneNumberFocused(){
                this.$trackEvent('FXView+Register+Phone');
            },
            handleContinueEvent(){
                this.$trackEvent('FXView+Register+Country+Changed');
                window.location.href = "https://global.fxview.com/register";
            },
            otpSubmitEvent(){
                this.$trackEvent('FXView+OTP+Submit+Success');
            },
            trackFzEvent(event){
                switch(event){
                    case 'fName':
                    this.$trackEvent('FXView+Register+Name'); 
                    break;
                    case 'email':
                    this.$trackEvent('FXView+Register+Email'); 
                    break;
                    case 'password':
                    this.$trackEvent('FXView+Register+Password'); 
                    break;
                    case 'country':
                    this.$trackEvent('FXView+Register+Country')
                    case 'otp':
                    this.$trackEvent('FXView+OTP+Focus');
                    break;
                }
            }
        },
        watch: {
            res_country(res_Value) {
                if (res_Value !== '' && res_Value !== null && res_Value !== undefined && !this.european_countries_list.hasOwnProperty(res_Value)) {
                    this.$trackEvent('FXView+Register+Country+Change+Popup');
                }
            },
            response_msg(newValue){
                if(newValue !== '' && this.msg_type === 'error'){
                    this.$trackEvent('FXView+Register+Email+Exist');
                }
            },
        },
        created(){
            this.$trackEvent('FXView+Register+Pageview');
			this._runGetCountriesList({'globalParams' : {} ,'localParams' : {'parameter' : this , 'page' : 'register'}})
			
            const _that = this

            this._runGetUserIp({'globalParams' :{},'localParams' :{ "parameter" : this } })
            
            //console.log("created---",this.$route.query)
            if(this.$route.query.investing_ref){
              this.$cookies.set( "investing_ref", this.$route.query.investing_ref, "1y", null, this.$env_var.cookieSaveUrl );
            }
            if("refLink" in this.$route.query && "refRm" in this.$route.query){
                // console.log("double----")
                this.$cookies.set("refLink",this.$route.query.refLink,"4y", null, this.$env_var.cookieSaveUrl);
                this.$cookies.set("refRm",this.$route.query.refRm,"4y", null, this.$env_var.cookieSaveUrl);
                this.$router.replace({query: null})
            }else if("refLink" in this.$route.query){
                // console.log("single----")
				let decrpyLinRm = window.atob(this.$route.query.refLink.toString()) ; 
				let decrpyLinRm1 = decrpyLinRm.split('||')
				this.admin_id = (decrpyLinRm1[0] != undefined)? decrpyLinRm1[0] : '0'
				this.rm_id = (decrpyLinRm1[1] != undefined)? decrpyLinRm1[1] : '0'
				
                const encyptKey =  this.$route.query['refLink']
                
                this.$cookies.set("IBREFERLINK", encyptKey, null, null, "fxview.com");
                this.IBREFERLINK = encyptKey
            } 
            if(this.$cookies.isKey("IBREFERLINK")){
                this.IBREFERLINK = this.$cookies.get("IBREFERLINK");
            }
            if("verify" in this.$route.query){
                const encyptKey =  this.$route.query['verify']
                let mykey = crypto.createDecipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let mystr = mykey.update(encyptKey, 'hex', 'utf8')
                mystr += mykey.final('utf8');
                let infoArray = mystr.split("^")
                if(_that.IBREFERLINK == ''){
                    _that.IBREFERLINK = infoArray[5]
                }
                let input_json={
                    'globalParams' :{
                        "email": infoArray[3],
                        "mobile": infoArray[4],
                        "password" : infoArray[2],
                        "OTP": infoArray[0],
                        "ID": infoArray[1],
                        "IBREFERLINK":_that.IBREFERLINK
                    },
                    'localParams' :{ "parameter" : _that }
                }
                _that._runVerifyLeadOtp(input_json)
                // console.log(mystr); //abc
            }  
        },
		mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.tabClass').length){
                    _that.tabActive = ''
                }
            });
            setTimeout(() => {
                try{
                    if(localStorage.getItem("ip_country")){
                        this.setCritio(localStorage.getItem("ip_country"))
                    }else{
                        /*fetch("https://ipapi.co/country?key=WqrqGPQYxfU6ySEZKqlU8bNDk9BgWVez4Uk3L4auzRyosaOWSs")*/
                        fetch("https://expapi.fxview.com/get/geo")
                        .then((res) => {
                            if (res.ok) { return res.text();
                            } else { throw new Error("HTTP Error " + res.status); }
                        }).then((country) => {
                            this.setCritio(country)
                        }).catch(function (error) { console.log(error); });
                    }
                }catch(error){ console.log(error); }
            }, "3000");     
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/register.vue